import * as React from 'react';
import Flex from '../../../components/Flex';
import FormField from '../../../components/FormField';
import {PillButton, BaseButton} from '../../../components/Button';
import TextField, {TextFieldProps} from '../../../components/TextField';
import Icon from '../../../components/Icon';
import Text from '../../../components/Text';
import {IconCheckCircle} from '../../../components/SvgIcon';
import {Form, FieldArray, FormikProps, getIn} from 'formik';
import {styled} from '../../../utils';

export type TeamInvitationFields = {
  fullName: string;
  email: string;
  role: string;
};

export interface FormValues {
  members: TeamInvitationFields[];
}

interface TeamInviteFormBaseProps extends FormikProps<FormValues> {
  loading: boolean;
}

// TODO: Add error message display capability to TextField component.
const ErrorMessage = ({children, show}: {children: React.ReactNode; show: boolean}) => {
  if (show) {
    return <div style={{fontFamily: 'Roboto', color: '#C00', padding: '8px 0'}}>{children}</div>;
  }
  return null;
};

const AddMemberButton = styled(BaseButton)(({theme}) => ({
  padding: 0
}));

export default class TeamInviteFormBase extends React.Component<TeamInviteFormBaseProps, {}> {
  public render() {
    const {values, errors, touched, handleChange, handleBlur, loading} = this.props;

    const commonFieldStyles = {
      width: '30%',
      marginBottom: 12
    };

    const commonFieldProps = {
      onChange: handleChange,
      onBlur: handleBlur,
      iconPosition: 'end'
    } as TextFieldProps;

    // TODO: add success state to TextField component
    const checkCircle = <IconCheckCircle color="#08C173" />;

    return (
      <Form>
        <FieldArray
          name="members"
          render={arrayHelpers => (
            <React.Fragment>
              {values.members.map((_, index) => {
                const fullNameFieldIndex = `members[${index}].fullName`;
                const emailFieldIndex = `members[${index}].email`;
                const roleFieldIndex = `members[${index}].role`;

                const emailError = getIn(errors, emailFieldIndex);
                const roleError = getIn(errors, roleFieldIndex);

                const emailTouched = getIn(touched, emailFieldIndex);
                const roleTouched = getIn(touched, roleFieldIndex);

                return (
                  <Flex key={index} justify="space-between">
                    <FormField label="Email" style={commonFieldStyles}>
                      <TextField
                        id={emailFieldIndex}
                        value={values[emailFieldIndex]}
                        icon={!emailError && emailTouched && checkCircle}
                        {...commonFieldProps}
                      />
                      <ErrorMessage show={Boolean(emailError && emailTouched)}>{emailError}</ErrorMessage>
                    </FormField>
                    <FormField label="Role" style={commonFieldStyles}>
                      <TextField
                        id={roleFieldIndex}
                        value={values[roleFieldIndex]}
                        icon={!roleError && roleTouched && checkCircle}
                        {...commonFieldProps}
                      />
                      <ErrorMessage show={Boolean(roleError && roleTouched)}>{roleError}</ErrorMessage>
                    </FormField>
                    <FormField label="Full name (optional)" style={commonFieldStyles}>
                      <TextField id={fullNameFieldIndex} value={values[fullNameFieldIndex]} {...commonFieldProps} />
                    </FormField>
                  </Flex>
                );
              })}

              <AddMemberButton type="button" onClick={() => arrayHelpers.push({email: '', role: '', fullName: ''})}>
                <Icon name="plus" />
                <Text color="primary" style={{marginLeft: 5}}>
                  Add a member
                </Text>
              </AddMemberButton>
            </React.Fragment>
          )}
        />

        <Flex justify="flex-end">
          <PillButton type="submit" variant="primary" loading={loading}>
            Next step
          </PillButton>
        </Flex>
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/TeamInviteForm/private/TeamInviteFormBase.tsx